// src/components/CategorySelector.js
import React from 'react';
import { categories } from '../data/offers';

export default function CategorySelector({ activeId, onSelect }) {
  return (
    <div className="popular-move-categories has-text-centered">
      {categories.map(cat => (
        <button
          key={cat.id}
          type="button"
          className={`button is-shadowless is-medium is-rounded white ${
            cat.id === activeId ? 'is-active' : ''
          }`}
          onClick={() => onSelect(cat.id)}
        >
          <span>{cat.label}</span>
        </button>
      ))}
    </div>
  );
}
